import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import useAuth from 'hooks/useAuth';

export interface ProtectedRouteProps extends RouteProps {
  isAuthenticated: boolean;
  isAdminRoute?: boolean;
  authenticationPath: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  isAuthenticated,
  isAdminRoute,
  authenticationPath,
  ...rest 
}) => {
  const { isAdmin, loadingAuthState, user } = useAuth();

  if (loadingAuthState) {

    return null;
  }

  // On a fresh page load the store's copy of the user (isAuthenticated) can arrive a moment after this
  // hook has finished checking; trusting the hook's own answer stops a direct link to /admin bouncing to
  // the home page (found in the Release 1 rehearsal, 5 Nov 2026).
  const signedIn = isAuthenticated || !!user;

  let redirectPath = '';
  if (!signedIn) {
    
    redirectPath = authenticationPath;
  } else if (isAdminRoute && !isAdmin) {
    
    redirectPath = '/';
  }

  if (redirectPath) {
    
    const renderComponent = () => <Redirect to={{ pathname: redirectPath }} />;
    return <Route {...rest} component={renderComponent} render={undefined} />;
  } else {
    
    return <Route {...rest} />;
  }
};

export default ProtectedRoute;
